import React from 'react';
import {
  TechemModal,
  TechemModalBody,
  TechemModalButtonFooter,
  TechemModalHeader
} from '@techem/ui-components';
import warningIcon from 'presentation/assets/icons/png/3x/icn-warning@3x.png';
import { useTranslation } from 'react-i18next';
import { TrackerUtil } from 'tracking/TrackerUtil';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <TechemModal
      isOpen={isOpen}
      modalTrackingId="modal-error"
      additionalTestId="error"
      header={
        <TechemModalHeader
          src={warningIcon}
          title={t('errorModalNoDataTitle')}
          titleAlignment="center"
        />
      }
      body={
        <TechemModalBody>
          <p className="text-center">{t('errorModalNoDataDescription')}</p>
        </TechemModalBody>
      }
      footer={
        <TechemModalButtonFooter
          primary={{
            text: t('closeModalText'),
            handleOnClick: onClose,
            additionalTestId: 'close'
          }}
          trackClickUsingTestId={(buttonIdentifier) =>
            TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, 'modal-error')
          }
        />
      }
    />
  );
};

export default ErrorModal;
